<div [formGroup]="form">
  <div class="row" *ngIf="form?.get('role')?.value">
    <div class="col-12">
      <mat-form-field2>
        <app-select
          label="Assigned To"
          formControlName="role"
          [items]="roles"
          bindValue="role"
          (selectionChange)="onRoleChange($event)"
          [searchable]="roles?.length > 6"
          [disabled]="!isRoleEditable"
          i18n-matTooltip
          matTooltip="Select a signing role that will be assigned to this field."
          matTooltipPosition="left"
        >
          <ng-template selectLabel let-items="items">
            <div class="role-select-item" *ngFor="let item of items">
              <span class="role-color" [style.background]="item.color"></span>&nbsp; {{ item.role }}
            </div>
          </ng-template>
          <ng-template selectItem let-item="item">
            <div class="role-select-item">
              <span class="role-color" [style.background]="item.color"></span>&nbsp; {{ item.role }}
            </div>
          </ng-template>
        </app-select>
      </mat-form-field2>
    </div>
    <div class="col-12 mb-3" *ngIf="isRequiredEditable">
      <mat-checkbox
        formControlName="required"
        i18n-matTooltip
        matTooltip="Select this option if you want to make completion of this field mandatory for the signer."
        matTooltipPosition="left"
        i18n
      >
        Required Field
      </mat-checkbox>
    </div>
    <div class="col-12" *ngIf="isEditableGuestDataDictField">
      <mat-checkbox
        i18n-matTooltip
        formControlName="readonly"
        matTooltip="When this box is checked, the field will be read-only, and signers will not be able to enter any information into the field. When this box is unchecked, the signer will be able to enter information into this field, and that information will automatically update the guest details for that signer."
        matTooltipPosition="left"
        i18n
      >
        Read-Only
      </mat-checkbox>
    </div>
  </div>
  <div class="row" [ngSwitch]="prefillType">
    <div class="col-12" *ngSwitchCase="'user'">
      <app-user-select
        [ctrl]="form.get('prefill_data_id')"
        [multiple]="false"
        (selected)="onPrefillUserSelected($event)"
        label="Select User"
      ></app-user-select>
    </div>
  </div>
  <div class="row" *ngIf="!disableCustomFont">
    <div class="col-12">
      <mat-form-field2 class="mat-block">
        <app-select
          formControlName="font"
          i18n-placeholder
          placeholder="Font Family"
          [searchable]="false"
          bindLabel="label"
          bindValue="id"
          [items]="fonts"
          i18n-matTooltip
          matTooltip="Select the font family that best matches the font family used in this template."
          matTooltipPosition="left"
        >
          <ng-template selectItem let-item="item">
            <div [style.fontFamily]="item.label">{{ item.label }}</div>
          </ng-template>
        </app-select>
      </mat-form-field2>
    </div>
    <div class="col-12">
      <mat-form-field2 class="mat-block">
        <app-select
          i18n-matTooltip
          i18n-placeholder
          formControlName="font_size"
          placeholder="Font Size"
          [searchable]="false"
          [items]="fontSizes"
          matTooltip="Select the font size that best matches the font size used in this template."
          matTooltipPosition="left"
        >
        </app-select>
      </mat-form-field2>
    </div>
  </div>
  <div class="row">
    <div class="col-12" *ngIf="isCustomField">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          type="text"
          i18n-placeholder
          placeholder="Label"
          formControlName="label"
          [required]="!!fillBeforeSentCtrl.value"
          i18n-matTooltip
          matTooltip="Enter a label that will be visible to the signer in the sent template. If you add a label to a textbox assigned to a guest signer, a new attribute will be created in the guest details with the value entered by the signer."
          matTooltipPosition="left"
        />
      </mat-form-field2>
    </div>
    <div class="col-12" *ngIf="isValueCustomizable">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          type="text"
          placeholder="Value"
          formControlName="value"
          i18n-matTooltip
          i18n-placeholder
          matTooltip="Enter a value for this textbox. This value can be numbers and/or letters, and will be inserted in place of this field. Signers will no longer be able to enter data into this field, when a value is already present."
          matTooltipPosition="left"
        />
      </mat-form-field2>
    </div>
    <div class="col-12" *ngIf="isValueCustomizable">
      <mat-checkbox
        formControlName="fill_before_sent"
        i18n-matTooltip
        matTooltip="Select this option if you want to enter a value for this textbox before sending the template. This can only be performed during manual template sends. A label is required when using this feature."
        matTooltipPosition="left"
        i18n
      >
        Fill Before Sending
      </mat-checkbox>
    </div>
  </div>
</div>
